import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RegionalMasksDto } from 'src/app/modules/shared/model/regionalMasksDto.model';
import { SelectItem } from 'primeng/api';
import { HttpErrorHandler } from './error-handler.service';
import { ApiResponse } from 'src/app/model/apiResponse.model';
import { CountryListItem } from '../model/countryListItem.model';

@Injectable({
  providedIn: 'root'
})
export class RegionalSettingsService {

  headers: HttpHeaders;
  apiServer: string;
  countryApiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService, private errorHandler: HttpErrorHandler) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/regions/';
    this.countryApiServer = 'api/countries';
   }

  /// Get a list of available countries for the related dropdown
  getCountryList(): Observable<Array<SelectItem>> {
    return this.http.get<ApiResponse>(this.apiRef.getApiUrl(`${this.countryApiServer}`))
    .pipe(map(res => res.result as CountryListItem[]))
    .pipe(map(res => res.map(i=> {return {label: i.Name, value: i.Code}}))) 
    .pipe(map(arr => arr as SelectItem<string>[]))
    .pipe(catchError(this.errorHandler.handleError));
    
  }

  //Determine if there is a default country code
  getDefaultCountry(): Observable<string> {
    return this.http.get<ApiResponse>(this.apiRef.getApiUrl(`${this.apiServer}default`))
    .pipe(map(res => res.result.Code))
    .pipe(catchError(this.errorHandler.handleError));
  }

  getRegionalMasks(region: string): Observable<RegionalMasksDto> {
    return this.http.get<ApiResponse>(this.apiRef.getApiUrl(`${this.apiServer}${region.toUpperCase()}`))
      .pipe(map(res => res.result))
      .pipe(map((resp: any)=>{
        if(resp && resp.Region){
        return ({
          Region: resp.Region.country,
          Phone: resp.Region.phoneNumMask,
          PhoneMask: this.getMask(resp.Region.phoneNumMask),
          Zip: resp.Region.zipCodeMask,
          ZipMask: this.getMask(resp.Region.zipCodeMask),
          States: this.getStates(resp.States)
        }) as RegionalMasksDto;
      } else{
        return ({
          Region: region,
          Phone: null,
          PhoneMask: null,
          Zip: null,
          ZipMask: null,
          States: this.getStates(resp?.States)
        }) as RegionalMasksDto;
      }
    }))
    .pipe(catchError(this.errorHandler.handleError));
  }

  getMask(mask: string){
    if(!mask){
      return null;
    }
    return mask.split('#').join('9')
            .split('A').join('a')
            .split('*').join('*')
            .split('[').join('')
            .split(']').join('');
  }

  getStates(states: any): Array<SelectItem> {
    if(!states){
      return null;
    }
    const arry = states as Array<SelectItem>;
    let options: Array<SelectItem> = new Array<SelectItem>();
    Object.keys(arry).forEach(s => {
      options.push({ label: s, value: s });
    });
    return options;
  }
}
